// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.


// Import JS
import menuOpen from "./menuOpen";
import setup from "./home";
import contactForm from "./contact-form";
// Call the menu and infinite scroll functions
menuOpen();
setup();
contactForm();

window.APP_ID = "svn5ks1d";

if (localStorage.getItem("theme") === "dark" ||
    (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme:dark)").matches)) {
    document.documentElement.classList.add("dark");
} else { document.documentElement.classList.remove("dark"); }
